
import type { FetchMeQuery } from '@mbfab/client-api'
import { Avatar } from 'antd'

export const SiderUser = ({ me }: { me: FetchMeQuery['me'] }) => {
  return (
    <div className="justify-left flex w-full cursor-pointer items-center px-4 py-6 align-middle hover:bg-slate-50 hover:opacity-90">
      <Avatar style={{ backgroundColor: '#DDD' }}>{me.name[0]}</Avatar>
      <div style={{ width: 140 }} className="flex items-center justify-between align-middle">
        <div className="text-sm ml-2" style={{ wordBreak: 'break-all' }} data-testid="sider-user-name">
          {ellipsisFilter(me.name, 13)}
          <br />
          <span className="text-xs text-gray-500">{ellipsisFilter(me.tenant.name, 19)}</span>
        </div>
      </div>
    </div>
  )
}

export function ellipsisFilter(str: unknown, x: number) {
  if (typeof str !== 'string') {
    return ''
  }

  if (str.length <= x) {
    return str
  }
  return str.slice(0, x) + '...'
}
